import { render } from "./allianceDistribution.vue?vue&type=template&id=7277b01b&scoped=true"
import script from "./allianceDistribution.vue?vue&type=script&lang=js"
export * from "./allianceDistribution.vue?vue&type=script&lang=js"

import "./allianceDistribution.vue?vue&type=style&index=0&id=7277b01b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7277b01b"]])

export default __exports__